var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummarySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    rx: 2,
    transform: "rotate(90 24 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74997 9.00003C3.74997 8.85169 3.79395 8.70668 3.87636 8.58333C3.95877 8.45999 4.07591 8.36386 4.21296 8.30709C4.35001 8.25032 4.50081 8.23547 4.6463 8.26441C4.79179 8.29335 4.92543 8.36479 5.03032 8.46968L12 15.4393L18.9696 8.46968C19.1103 8.32903 19.3011 8.25001 19.5 8.25001C19.6989 8.25001 19.8897 8.32903 20.0303 8.46968C20.171 8.61034 20.25 8.80111 20.25 9.00003C20.25 9.19895 20.171 9.38972 20.0303 9.53037L12.5303 17.0304C12.4607 17.1 12.378 17.1553 12.287 17.193C12.196 17.2307 12.0985 17.2501 12 17.2501C11.9015 17.2501 11.804 17.2307 11.713 17.193C11.622 17.1553 11.5393 17.1 11.4696 17.0304L3.96963 9.53037C3.89989 9.4608 3.84457 9.37813 3.80688 9.28712C3.76918 9.19611 3.74984 9.09854 3.74997 9.00003Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarySmall);
export default __webpack_public_path__ + "static/media/summary-small.41a5758b4ef64d670d1a070417e314e6.svg";
export { ForwardRef as ReactComponent };